<template>
  <div
    class="staff__contact flex items-center px-2 pt-2"
    :class="{'bg-primary-gradient text-white shadow-lg': isActive, 'bg-white': !isActive}"
    :style="`border-left: 5px solid ${staffData.color_code ? staffData.color_code : '#2979FF'}`"
  >
    <!-- <div class="staff__contact flex items-center px-2 pt-4 pb-2" :class="{'bg-primary-gradient text-white shadow-lg': isActive}"> -->
    <!-- <div style="width: 10px; height: 10px; min-width: 10px; border: 1px solid #fff; border-radius: 50%" :style="`background: ${staffData.color_code ? staffData.color_code : '#2979FF'}`"></div> -->
    <!-- <div style="width: 10px; height: 10px; min-width: 10px; border: 1px solid #fff;" :style="`background: ${staffData.color_code ? staffData.color_code : '#2979FF'}`"></div> -->
    <feather-icon icon="MoveIcon" svgClasses="w-5 stroke-current mx-2 cursor-pointer icon-group move-btn mb-2" v-if="!fromStaffBlockTime"/>
    <div class="contact__avatar mr-1">
      <!-- <img v-if="staffData.image_url != null"  class="avatar-list border-2 border-solid border-white" /> -->
      <vs-avatar
        :src="staffData.image_url"
        class="border-2 border-solid border-white text-xl"
        size="42px"
        :text="StringHelper.changeFormatAvatar(staffData.name)"
        :color="staffData.color_code"
      ></vs-avatar>
      <!-- <vs-avatar class="border-2 border-solid border-white" size="42px" :text="staffData.name"></vs-avatar> -->
    </div>
    <div class="contact__container w-full flex items-center justify-between overflow-hidden">
      <div class="contact__info flex w-full">
        <div class="flex flex-col truncate">
          <h6 class="pr-2 font-semibold truncate" :class="{'text-white': isActive}">{{staffData.name}}</h6>
          <!-- <span class="truncate text-xs">{{staffData.code}}</span> -->
        </div>

        <div class="ml-auto w-1/12 mr-4">
          <div v-if="staffData.status">
            <feather-icon icon="CheckIcon" svgClasses="w-6 h-6 stroke-current text-primary" v-if="!isActive" />
            <feather-icon icon="CheckIcon" svgClasses="w-6 h-6 stroke-current text-white" v-else />
          </div>
          <div v-else>
            <feather-icon icon="XIcon" svgClasses="w-6 h-6 stroke-current text-danger" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { StringHelper } from "../../models/string_helper";
export default {
  name: "staff-item",
  props: {
    isActive: { type: Boolean },
    staffData: { type: Object, required: true },
    fromStaffBlockTime: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      StringHelper
    };
  }
  // data() {
  //     return {
  //         avatarColor: ''
  //     }
  // },
  // methods: {
  //     getRandomColor() {
  //         const colorArray = ['#9b59b6', '#e67e22', '#1abc9c', '#d35400', '#2980b9', '#2980b9', '#3498db',
  //                             '#2ecc71', '#95a5a6', '#f1c40f', '#e74c3c', '#2c3e50', '#16a085', '#7f8c8d'];
  //         return colorArray[Math.floor(Math.random()*colorArray.length)];
  //     },
  //     emitColor() {
  //         this.$emit('AvatarColor', this.avatarColor);
  //     }
  // },
  // created() {
  //     this.avatarColor = this.getRandomColor();
  //     this.emitColor();
  // }
};
</script>
